import { render, staticRenderFns } from "./GerenciarElementosPrimariosConsolidados.vue?vue&type=template&id=60a16448&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./GerenciarElementosPrimariosConsolidados.vue?vue&type=style&index=0&id=60a16448&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a16448",
  null
  
)

export default component.exports